/* TCC product-page DOM tweak.

   Spotlight renders each product "block" (price, inventory, quantity, tax,
   buy-form) as a direct child of .product__info-container. Once we flatten
   info-wrapper + info-container with `display: contents`, those blocks
   become direct grid items of .product alongside the (much taller) middle
   description column. CSS grid uses one row size per row across all
   columns, so the row that holds the price stretches to match the
   description's height — leaving a big gap between £price and "in stock".

   This script wraps the right-column blocks in a single .tcc-buy-stack
   div on page load. With one grid item in col 3, that cell's height
   is independent of the description column. Inside the wrapper we flex
   the items tightly with `gap: 0.4rem`. */
(function () {
  function wrap() {
    var containers = document.querySelectorAll('.product__info-container');
    containers.forEach(function (container) {
      if (container.querySelector(':scope > .tcc-buy-stack')) return;

      var selectors = [
        '[id^="price-template-"]',
        '.product__inventory',
        '[class*="product-form__quantity"]',
        '.product__tax',
        '.tcc-points-earn',
        '.tcc-fav-badge',
        '.product-form',
        'product-form',
        '.product-form__buttons',
        '.shopify-payment-button',
        '.shopify-payment-button-wrapper',
        '.tcc-restock-notify'
      ];

      var items = [];
      selectors.forEach(function (sel) {
        container.querySelectorAll(':scope > ' + sel).forEach(function (el) {
          if (items.indexOf(el) === -1) items.push(el);
        });
      });

      container.querySelectorAll(':scope > *').forEach(function (el) {
        if (items.indexOf(el) !== -1) return;
        if (
          el.querySelector(':scope > product-form') ||
          el.querySelector(':scope > .product-form__buttons') ||
          el.querySelector(':scope > .shopify-payment-button')
        ) {
          items.push(el);
        }
      });

      if (items.length === 0) return;

      var stack = document.createElement('div');
      stack.className = 'tcc-buy-stack';
      items[0].parentNode.insertBefore(stack, items[0]);
      items.forEach(function (el) { stack.appendChild(el); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrap);
  } else {
    wrap();
  }
  document.addEventListener('shopify:section:load', wrap);
})();


/* Customer photos gallery — fallback arrow buttons.
   judgeme-merge.js owns the full carousel (auto-advance, viewport wrap,
   arrows) on /pages/reviews. On every other page that renders .jdgm-gallery
   (the product page widget, primarily), there's no carousel JS — the
   gallery scrolls horizontally via our CSS but has no nav arrows.
   This block adds simple prev/next arrows ONLY when judgeme-merge.js's
   .tcc-gallery-carousel__arrow buttons aren't already present, so the
   two never collide. */
(function () {
  function addFallbackArrows() {
    document.querySelectorAll('.jdgm-gallery-wrapper').forEach(function (wrap) {
      if (wrap.dataset.tccFallbackArrows === '1') return;
      // Skip if judgeme-merge.js's carousel has run on this wrap.
      if (wrap.querySelector('.tcc-gallery-carousel__arrow')) return;
      var gallery = wrap.querySelector('.jdgm-gallery');
      if (!gallery) return;
      wrap.dataset.tccFallbackArrows = '1';

      // The wrap needs to be positioned for our absolute-positioned arrows.
      if (getComputedStyle(wrap).position === 'static') {
        wrap.style.position = 'relative';
      }

      ['prev', 'next'].forEach(function (dir) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tcc-gallery-fallback-arrow tcc-gallery-fallback-arrow--' + dir;
        btn.setAttribute('aria-label', dir === 'prev' ? 'Previous photos' : 'Next photos');
        btn.innerHTML = dir === 'prev' ? '‹' : '›';
        btn.addEventListener('click', function () {
          var step = Math.max(140, Math.floor(gallery.clientWidth * 0.7));
          gallery.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
        });
        wrap.appendChild(btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addFallbackArrows);
  } else {
    addFallbackArrows();
  }
  // Re-try a few times — Judge.me lazy-renders galleries.
  var attempts = 0;
  function retry() {
    addFallbackArrows();
    if (attempts++ < 12) setTimeout(retry, 500);
  }
  retry();
})();


/* Judge.me reviews: bypass the widget's pagination entirely by fetching
   every review directly from Judge.me's public API and rendering them as
   one continuous list inside the existing widget container.

   Why this approach:
   The previous attempts (intercepting pagination clicks, MutationObserver,
   IntersectionObserver) all ended up fighting Judge.me's own scroll-to-
   widget behaviour and click handlers. This skips Judge.me's JS entirely:
   call https://api.judge.me/reviews/reviews_for_widget directly with the
   product_id we read off the page, parse the returned HTML chunks, and
   drop them into .jdgm-rev-widg__reviews. Pagination UI gets hidden.

   The API endpoint is anonymous (CORS: *), caps at 30 reviews per page,
   and returns JSON with an `html` field containing the same markup
   Judge.me would have rendered on the server — so all of Judge.me's
   existing CSS keeps styling the reviews. */

(function () {
  var DEBUG = false;
  var PER_PAGE = 30;
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[tcc-reviews]'].concat([].slice.call(arguments))); }

  function getProductId() {
    if (window.meta && window.meta.product && window.meta.product.id) return window.meta.product.id;
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id) return window.ShopifyAnalytics.meta.product.id;
    var any = document.querySelector('[data-product-id]');
    return any ? any.getAttribute('data-product-id') : null;
  }
  function getShopDomain() {
    if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    return null;
  }

  function fetchReviewsPage(shop, pid, page) {
    var url = 'https://api.judge.me/reviews/reviews_for_widget'
      + '?shop_domain=' + encodeURIComponent(shop)
      + '&platform=shopify'
      + '&product_id=' + encodeURIComponent(pid)
      + '&per_page=' + PER_PAGE
      + '&page=' + page;
    return fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); });
  }

  function extractReviewsHTML(rawHtml) {
    if (!rawHtml) return '';
    // The API response is two sibling blocks: the reviews container AND a
    // pagination bar after it. Use DOMParser-style extraction so we only
    // pick the .jdgm-rev-widg__reviews children — a regex with $ anchors
    // would greedily consume the trailing pagination div too.
    var tmp = document.createElement('div');
    tmp.innerHTML = rawHtml;
    var inner = tmp.querySelector('.jdgm-rev-widg__reviews');
    if (inner) return inner.innerHTML;
    // Fallback: gather any standalone review nodes.
    var out = '';
    var revs = tmp.querySelectorAll('.jdgm-rev');
    for (var i = 0; i < revs.length; i++) out += revs[i].outerHTML;
    return out;
  }

  /* Judge.me normally converts each timestamp from data-content="YYYY-MM-DD
     HH:MM:SS UTC" to a relative string like "3 days ago". Since we inject
     reviews after its init, the elements would stay as spinners — replace
     them with our own formatting. */
  function formatTimestamps(root) {
    var els = root.querySelectorAll('.jdgm-rev__timestamp');
    var now = Date.now();
    Array.prototype.forEach.call(els, function (el) {
      var raw = el.getAttribute('data-content');
      if (!raw) return;
      var iso = raw.replace(' UTC', 'Z').replace(' ', 'T');
      var t = Date.parse(iso);
      if (isNaN(t)) return;
      var diff = Math.max(0, (now - t) / 1000);
      var text;
      if (diff < 60) text = 'just now';
      else if (diff < 3600) text = Math.floor(diff / 60) + ' minutes ago';
      else if (diff < 86400) text = Math.floor(diff / 3600) + ' hours ago';
      else if (diff < 86400 * 7) text = Math.floor(diff / 86400) + ' days ago';
      else if (diff < 86400 * 30) text = Math.floor(diff / (86400 * 7)) + ' weeks ago';
      else if (diff < 86400 * 365) text = Math.floor(diff / (86400 * 30)) + ' months ago';
      else text = Math.floor(diff / (86400 * 365)) + ' years ago';
      el.textContent = text;
      el.classList.remove('jdgm-spinner');
    });
  }

  function hideAllPagination() {
    document.querySelectorAll('.jdgm-paginate').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  /* If Judge.me's runtime clears our injection after init, re-inject.
     Watches for child-list changes and re-fills if the reviews disappear.
     Stops observing after 30s of stability. */
  function guardContent(jdgmRoot, expectedHTML) {
    // Count how many reviews we just injected (parse HTML once).
    var tmp = document.createElement('div');
    tmp.innerHTML = expectedHTML;
    var expectedCount = tmp.querySelectorAll('.jdgm-rev').length;
    var threshold = Math.max(5, Math.floor(expectedCount * 0.5));

    var idle;
    var observer = new MutationObserver(function () {
      clearTimeout(idle);
      idle = setTimeout(function () {
        var got = jdgmRoot.querySelectorAll('.jdgm-rev').length;
        if (got < threshold) {
          log('detected widget clear (got ' + got + ' < ' + threshold + ') — re-injecting');
          jdgmRoot.innerHTML = expectedHTML;
          formatTimestamps(jdgmRoot);
          hideAllPagination();
        }
      }, 100);
    });
    observer.observe(jdgmRoot, { childList: true });
    setTimeout(function () { observer.disconnect(); }, 30000);
  }

  function findWidgetMountPoint() {
    // Preferred: Judge.me's own reviews list container.
    var el = document.querySelector('.jdgm-rev-widg__reviews');
    if (el) return { el: el, source: 'jdgm-rev-widg__reviews' };
    // Fallback: the widget body, anything inside .jdgm-rev-widg.
    el = document.querySelector('.jdgm-rev-widg__body');
    if (el) return { el: el, source: 'jdgm-rev-widg__body' };
    el = document.querySelector('.jdgm-rev-widg');
    if (el) return { el: el, source: 'jdgm-rev-widg' };
    // Last resort: the Judge.me section wrapper used by Shopify.
    el = document.getElementById('judgeme_product_reviews') ||
         document.querySelector('[id^="judgeme"], [class*="judgeme"]');
    if (el) return { el: el, source: el.id || el.className };
    return null;
  }

  function loadAllReviews() {
    var jdgmRoot = document.querySelector('.jdgm-rev-widg__reviews');
    if (!jdgmRoot) return false;
    if (jdgmRoot.dataset.tccStacked === '1') return true;

    var productId  = getProductId();
    var shopDomain = getShopDomain();
    if (!productId || !shopDomain) {
      log('missing productId or shopDomain — skip. productId=', productId, 'shopDomain=', shopDomain);
      return false;
    }
    jdgmRoot.dataset.tccStacked = '1';
    hideAllPagination();
    // Inject INTO the Judge.me container so all of Judge.me's CSS selectors
    // (which scope styling to descendants of .jdgm-rev-widg__reviews) keep
    // applying. The guardContent observer re-fills if Judge.me's runtime
    // clears it.
    jdgmRoot.innerHTML = '<p style="text-align:center;opacity:0.6;padding:24px;color:inherit;">Loading reviews…</p>';
    log('fetching reviews for product', productId, 'on shop', shopDomain);

    fetchReviewsPage(shopDomain, productId, 1).then(function (first) {
      var total = first.total_count || 0;
      var totalPages = Math.max(1, Math.ceil(total / PER_PAGE));
      log('total reviews =', total, '/ pages =', totalPages);

      if (totalPages <= 1) {
        var only = extractReviewsHTML(first.html);
        jdgmRoot.innerHTML = only;
        formatTimestamps(jdgmRoot);
        guardContent(jdgmRoot, only);
        return;
      }

      var rest = [];
      for (var p = 2; p <= totalPages; p++) rest.push(fetchReviewsPage(shopDomain, productId, p));
      return Promise.all(rest).then(function (others) {
        var combined = extractReviewsHTML(first.html);
        others.forEach(function (d) { combined += extractReviewsHTML(d.html); });
        jdgmRoot.innerHTML = combined;
        formatTimestamps(jdgmRoot);
        hideAllPagination();
        guardContent(jdgmRoot, combined);
        log('all reviews rendered. count=', jdgmRoot.querySelectorAll('.jdgm-rev').length);
      });
    }).catch(function (e) {
      log('error fetching reviews:', e);
      jdgmRoot.dataset.tccStacked = '';
      document.querySelectorAll('.jdgm-paginate').forEach(function (el) { el.style.display = ''; });
    });

    return true;
  }

  var attempts = 0;
  function tryStart() {
    if (loadAllReviews()) return;
    if (attempts++ < 60) setTimeout(tryStart, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryStart);
  } else {
    tryStart();
  }
})();


/* Booster-box cart-page warning. The hard limit (5 per SKU per buyer per
   7d, matched on email OR address) is enforced in checkout by the Shopify
   Cart Validation Function deployed via the TCC Master app. This is the
   soft signal that fires earlier — on the cart page itself — when a single
   booster box SKU appears with quantity > 5. Tuned for Spotlight: rows are
   <tr class="cart-item" id="CartItem-{cart.items index+1}">. */
(function () {
  var BOX_SKU_REGEX = /-BOX$/i;
  var LIMIT = 5;
  var MESSAGE = "You've reached your limit for this item. To order more, email alex@thechase.club.";

  function inject(line) {
    if (line.querySelector('.tcc-box-limit-warning')) return;
    var w = document.createElement('div');
    w.className = 'tcc-box-limit-warning';
    w.style.cssText = 'color:#cba135;border:1px solid #cba135;padding:8px 12px;border-radius:4px;margin-top:8px;font-size:13px;line-height:1.4;background:rgba(203,161,53,0.08);';
    w.textContent = MESSAGE;
    var details = line.querySelector('.cart-item__details') || line;
    details.appendChild(w);
  }
  function removeAll() {
    document.querySelectorAll('.tcc-box-limit-warning').forEach(function (w) { w.remove(); });
  }
  function rowForIndex(i) {
    return document.getElementById('CartItem-' + (i + 1));
  }

  function scanCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        removeAll();
        (cart.items || []).forEach(function (item, idx) {
          var sku = item.sku || '';
          if (!BOX_SKU_REGEX.test(sku)) return;
          if ((item.quantity || 0) <= LIMIT) return;
          var row = rowForIndex(idx);
          if (row) inject(row);
        });
      })
      .catch(function () { /* silent — fall through to checkout validator */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCart);
  } else {
    scanCart();
  }
  document.addEventListener('cart:updated', scanCart);
  document.addEventListener('cart:refresh', scanCart);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[name="updates[]"], input.quantity__input, [data-quantity-input]')) {
      setTimeout(scanCart, 400);
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('quantity-input button, .quantity__button')) {
      setTimeout(scanCart, 600);
    }
  });
})();
/* tcc-restock-v2 (28 Sep 2026) — back-in-stock signup. One delegated handler serves the inline
   form on sold-out product pages AND the "Notify Me" popup opened from collection cards
   (snippet tcc-restock-notify, modes inline / button). Boxes and packs. */
(function () {
  if (window.__tccRestockV2) return;
  window.__tccRestockV2 = true;
  var ENDPOINT = '/apps/membership/restock/subscribe';

  function say(root, text, ok) {
    var msg = root.querySelector('.tcc-rn__msg');
    if (!msg) return;
    msg.textContent = text;
    msg.className = 'tcc-rn__msg ' + (ok ? 'is-ok' : 'is-err');
    msg.hidden = false;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('.tcc-rn__form') : null;
    if (!form) return;
    e.preventDefault();
    var root = form.closest('.tcc-restock-notify');
    if (!root) return;
    var input = form.querySelector('.tcc-rn__input');
    var btn = form.querySelector('.tcc-rn__btn');
    var email = ((input && input.value) || '').trim();
    if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
      return say(root, 'Please enter a valid email address.', false);
    }
    btn.disabled = true;
    btn.textContent = 'Saving…';
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sku: root.dataset.sku,
        variant_id: root.dataset.variant,
        email: email,
        source: root.dataset.source || 'product-page'
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && res.body.error) || 'failed');
        form.hidden = true;
        say(root, res.body.already
          ? "You're already on the list for this one — we'll be in touch."
          : "You're on the list. We'll email you the moment it's back.", true);
        // Card button that opened the popup: mark it done so it isn't clicked twice.
        if (root.dataset.source === 'collection-card' && lastOpener) {
          var span = lastOpener.querySelector('span');
          if (span) span.textContent = "You're on the list";
          lastOpener.disabled = true;
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Notify Me';
        say(root, err.message === 'bad_email'
          ? 'That email address does not look right.'
          : 'Sorry, something went wrong. Please try again.', false);
      });
  });

  /* ---- popup for collection cards ---- */
  var modal = null, lastOpener = null;
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'tcc-rn-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="tcc-rn-modal__backdrop"></div>' +
      '<div class="tcc-rn-modal__card" role="dialog" aria-modal="true" aria-labelledby="tcc-rn-modal-title" tabindex="-1">' +
        '<button type="button" class="tcc-rn-modal__close" aria-label="Close">&times;</button>' +
        '<div class="tcc-rn-modal__body"></div>' +
      '</div>';
    document.body.appendChild(modal);
    return modal;
  }
  function openModal(btn) {
    var d = btn.dataset, m = ensureModal(), body = m.querySelector('.tcc-rn-modal__body');
    var uid = 'tcc-rn-email-modal-' + (d.variant || '0');
    body.innerHTML =
      '<p class="tcc-rn-modal__kicker">Sold out</p>' +
      '<div class="tcc-restock-notify" data-sku="' + esc(d.sku) + '" data-variant="' + esc(d.variant) + '"' +
        ' data-lang="' + esc(d.lang) + '" data-kind="' + esc(d.kind) + '" data-source="collection-card">' +
        '<p class="tcc-rn__title" id="tcc-rn-modal-title">Get notified when ' + esc(d.set) + (d.kind ? ' ' + esc(d.kind) + ' restock' : ' restocks') + '</p>' +
        '<form class="tcc-rn__form" novalidate>' +
          '<label class="visually-hidden" for="' + uid + '">Email address</label>' +
          '<input class="tcc-rn__input" id="' + uid + '" type="email" name="email" inputmode="email" autocomplete="email" placeholder="you@example.com" required>' +
          '<button class="tcc-rn__btn" type="submit">Notify Me</button>' +
        '</form>' +
        '<p class="tcc-rn__msg" role="status" aria-live="polite" hidden></p>' +
      '</div>';
    lastOpener = btn;
    m.hidden = false;
    document.documentElement.classList.add('tcc-rn-lock');
    var input = body.querySelector('.tcc-rn__input');
    setTimeout(function () { if (input) input.focus(); }, 30);
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('tcc-rn-lock');
    if (lastOpener && lastOpener.focus) lastOpener.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('.tcc-rn-open');
    if (opener) { e.preventDefault(); e.stopPropagation(); openModal(opener); return; }
    if (t.closest('.tcc-rn-modal__close') || (t.classList && t.classList.contains('tcc-rn-modal__backdrop'))) closeModal();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
})();
